// Thin wrappers over the gtag.js instance already loaded by the static
// script in public/index.html (see that file for why it's static, not
// React-injected). No react-ga4 here — initializing a second GA instance
// on top of the static one would double-load gtag.js and double-fire the
// initial pageview via its own `gtag('config', ...)` call.

export const trackEvent = (action, category, label, value) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};

export const trackPageView = (path) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  });
};

const SESSION_TRAFFIC_SOURCE_KEY = 'ga_traffic_source';

// Detects organic vs. invite traffic on first load, persists it for the rest
// of the session (sessionStorage, not localStorage — each new tab/session
// re-detects), and sets it as a GA user property so every later event in the
// session carries the label without needing to pass it around explicitly.
export const initTrafficSource = () => {
  if (typeof window.gtag !== 'function') return;
  let source;
  try {
    source = sessionStorage.getItem(SESSION_TRAFFIC_SOURCE_KEY);
  } catch (_) {
    // ignore storage errors (private browsing, etc.)
  }
  if (!source) {
    const params = new URLSearchParams(window.location.search);
    source = params.has('token') ? 'invite' : 'organic';
    try {
      sessionStorage.setItem(SESSION_TRAFFIC_SOURCE_KEY, source);
    } catch (_) {
      // ignore storage errors
    }
  }
  window.gtag('set', 'user_properties', { traffic_source: source });
  trackEvent('session_start_source', 'Traffic', source);
};

export const getTrafficSource = () => {
  try {
    return sessionStorage.getItem(SESSION_TRAFFIC_SOURCE_KEY) || 'organic';
  } catch (_) {
    return 'organic';
  }
};

// Binds a GA user_id to a candidate id so events before and after login (or
// across sessions) can be attributed to the same person in GA4.
export const setGaUserId = (candidateId) => {
  if (!candidateId || typeof window.gtag !== 'function') return;
  window.gtag('set', { user_id: String(candidateId) });
  window.gtag('set', 'user_properties', { candidate_id: String(candidateId) });
};
